import { render, staticRenderFns } from "./carusel.vue?vue&type=template&id=023ca03c&scoped=true&"
import script from "./carusel.vue?vue&type=script&lang=js&"
export * from "./carusel.vue?vue&type=script&lang=js&"
import style0 from "./carusel.vue?vue&type=style&index=0&id=023ca03c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023ca03c",
  null
  
)

export default component.exports